// extracted by mini-css-extract-plugin
export var root = "PlasmicAuthorBio-module--root--248xC";
export var svg__gvhTy = "PlasmicAuthorBio-module--svg__gvhTy--3WpPA";
export var box = "PlasmicAuthorBio-module--box--1lUdj";